<jhi-spinner *ngIf="loading"></jhi-spinner>
<jhi-alert></jhi-alert>
<!--TODO: Risolvere bug della tabella durante lo zoom intermedio -->
<div class="container mt-4">
  <nav class="breadcrumb-container" aria-label="Percorso di navigazione">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a href="javascript:void(0)" (click)="goToHome()">Home</a><span class="separator">/</span></li>
      <li class="breadcrumb-item active"><a href="javascript:void(0)">Lista prenotazioni</a></li>
    </ol>
  </nav>
</div>
<div class="container-fluid text-center my-2">
  <span class="h4" jhiTranslate="lista-prenotazioni.title"
        *ngIf="this.appuntamenti !== null && this.appuntamenti.length > 0">I miei Appuntamenti</span>
  <form [formGroup]="pageFormFiltro">
    <div class="d-flex justify-content-end" style="padding-bottom: 0; ">
      <button class="btn btn-primary btn-icon btn-me primary-button" data-bs-toggle="dropdown">
        <svg class="icon icon-white mx-1">
          <use
            href="./content/svg/sprites.svg#it-funnel"
          ></use>
        </svg>
        <span jhiTranslate="istanze.filtra.titolo">Filtra</span>
      </button>
      <div class="dropdown-menu dismissible w-35" role="menu">
        <div class="container-fluid my-2">
          <div class="row justify-content-between mb-2">
            <div class="col">
              <h5 class="fw-bold" jhiTranslate="istanze.filtra.filtraRicerca">Filtra ricerca</h5>
            </div>
            <div class="col">
              <button type="button" class="btn-close float-end" data-bs-dismiss="menu"
                      aria-label="Chiudi avviso"></button>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-lg-6">
              <label for="dataInizio" jhiTranslate="istanze.filtra.dataIni">Data Inizio</label>
              <input type="date" id="dataInizio" formControlName="dataInizio">
            </div>
            <div class="col-lg-6">
              <label for="dataFine" jhiTranslate="istanze.filtra.dataFin">Data Fine</label>
              <input type="date" id="dataFine" formControlName="dataFine">
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-lg-6">
              <label for="servizioID" class="mt-3" jhiTranslate="istanze.servizio">Servizio</label>
              <div class="select-wrapper">
                <select id="servizioID" formControlName="servizio">
                  <option value="" jhiTranslate="pagamenti.filtra.servizio.def">Tutti i servizi</option>
                  <option *ngFor="let servizio of servizi"
                          [value]="servizio.id">{{servizio.nmServizio}}</option>
                </select>
              </div>
            </div>
            <div class="col-lg-6">
              <label for="stato" class="mt-3" jhiTranslate="istanze.stato">Stato</label>
              <div class="select-wrapper">
                <select id="stato" formControlName="stato">
                  <option selected value="" jhiTranslate="pagamenti.filtra.stati.def">Qualsiasi Stato</option>
                  <option value="F" style="color: blue" jhiTranslate="pagamenti.filtra.stati.programmato">Programmato
                  </option>
                  <option value="T" style="color: #ff8000" jhiTranslate="pagamenti.filtra.stati.trasferito">Trasferito
                  </option>
                  <option value="A" style="color: red" jhiTranslate="pagamenti.filtra.stati.annullato">Annullato
                  </option>
                  <option value="C" style="color: green" jhiTranslate="pagamenti.filtra.stati.confermato">Confermato
                  </option>
                  <option value="M" style="color: red" jhiTranslate="pagamenti.filtra.stati.mancato">Mancato</option>
                  <option value="D" style="color: red" jhiTranslate="pagamenti.filtra.stati.assenzaDipendente">
                    Dipendente assente
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-lg-4 mb-1">
              <button (click)="getAppuntamentiPage()" class="btn btn-primary btn-xs btn-me w-100" type="button">
                <span jhiTranslate="pagamenti.filtra.applica">Applica</span>
              </button>
            </div>
            <div class="col-lg-4 mb-1">
              <button (click)="pulisciFiltri()" class="btn btn-danger btn-xs btn-me w-100" type="button">
                <span jhiTranslate="pagamenti.filtra.rimuovi">Rimuovi</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
  <div class="card-wrapper mt-3 d-flex justify-content-center" style="padding-bottom: 0; ">
    <div class="card card-bg border-bottom-card" *ngIf="this.appuntamenti != null && this.appuntamenti.length > 0">
      <div class="card-body">
        <div class="table-responsive " style="overflow-x: hidden">
          <table class="table table-striped ">
            <caption hidden>Tabella lista prenotazioni</caption>
            <thead>
            <tr>
              <th scope="col" jhiTranslate="form.appuntamento.codPrenotazione">Codice Prenotazione</th>
              <th scope="col" jhiTranslate="riepilogoAppuntamento.Dichiarante">Dichiarante</th>
              <th *ngIf="ordinamentoData === 'desc'" scope="col" (click)="changeStatoOrdinamento()"
                  style="cursor: pointer"><span jhiTranslate="lista-prenotazioni.data">Data</span>
                <svg class="icon icon-sm icon-black">
                  <use
                    href="./content/svg/sprites.svg#it-arrow-down"
                  ></use>
                </svg>
              </th>
              <th *ngIf="ordinamentoData === 'asc'" scope="col" (click)="changeStatoOrdinamento()"
                  style="cursor: pointer"><span jhiTranslate="lista-prenotazioni.data">Data</span>
                <svg class="icon icon-sm icon-black">
                  <use
                    href="./content/svg/sprites.svg#it-arrow-up"
                  ></use>
                </svg>
              </th>
              <th scope="col" jhiTranslate="lista-prenotazioni.ora">Ora</th>
              <th scope="col" jhiTranslate="lista-prenotazioni.servizio">Servizio</th>
              <th scope="col" jhiTranslate="lista-prenotazioni.operatore">Operatore</th>
              <th scope="col" jhiTranslate="lista-prenotazioni.stato">Stato</th>
              <th scope="col"></th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let appuntamento of appuntamenti; index as i" class="grow">
              <td (click)="sendAppointment(appuntamento)">{{appuntamento.content.cdPrenotazione}}</td>
              <td class="fw-bold"
                  (click)="sendAppointment(appuntamento)"
                  *ngIf="appuntamento.dichiarante">{{appuntamento.dichiarante.nome}} {{appuntamento.dichiarante.cognome}}</td>
              <td *ngIf="!appuntamento.dichiarante" class="fw-bold">-</td>
              <td class="data"
                  (click)="sendAppointment(appuntamento)">{{appuntamento.content.dataPrenotazione | date:'dd/MM/yyyy'}}</td>
              <td (click)="sendAppointment(appuntamento)">{{formatTime(appuntamento.content.hhInizio)}}
                - {{formatTime(appuntamento.content.hhFine)}}</td>
              <td
                (click)="sendAppointment(appuntamento)">{{appuntamento.content.servizioErogato.servizio.nmServizio}}</td>
              <td (click)="sendAppointment(appuntamento)" class="fw-bold"
                  *ngIf="appuntamento.dipendente">{{appuntamento.dipendente.nmNome}} {{appuntamento.dipendente.nmCognome}}</td>
              <td *ngIf="!appuntamento.dipendente" class="fw-bold">-</td>
              <td [ngSwitch]="appuntamento.content.tiStato" (click)="sendAppointment(appuntamento)">
                <span *ngSwitchCase="'F'" style="color: blue"><span jhiTranslate="pagamenti.filtra.stati.programmato" *ngIf="appuntamento.content.servizioErogato.servizio.codice != CD_SERVIZIO_SALE">Programmato</span><span *ngIf="appuntamento.content.servizioErogato.servizio.codice == CD_SERVIZIO_SALE">Da confermare</span></span>
                <span *ngSwitchCase="'C'" style="color: green"><span *ngIf="appuntamento.content.servizioErogato.servizio.codice != CD_SERVIZIO_SALE" jhiTranslate="pagamenti.filtra.stati.completato">Completato</span><span *ngIf="appuntamento.content.servizioErogato.servizio.codice == CD_SERVIZIO_SALE">Confermato</span></span>
                <span *ngSwitchCase="'A'" style="color: red" jhiTranslate="pagamenti.filtra.stati.annullato">Annullato</span>
                <span *ngSwitchCase="'T'" style="color: #ff8000" jhiTranslate="pagamenti.filtra.stati.trasferito">Trasferito</span>
                <span *ngSwitchCase="'M'" style="color: red" jhiTranslate="pagamenti.filtra.stati.mancato">Mancato</span>
                <span *ngSwitchCase="'D'" style="color: red" jhiTranslate="pagamenti.filtra.stati.assenzaDipendente">Dipendente assente</span>
              </td>
              <td *ngIf="appuntamento.content.flCancellazione; else sendApp">
                <a class="table-svg fade show" (click)="formPatchValue(appuntamento.content.id)"
                   data-container="body" data-bs-toggle="modal" data-bs-target="#modal1" data-bs-trigger="hover"
                   data-bs-placement="top" data-html="true" title="Cancella appuntamento"
                   data-bs-content="Disabilita appuntamento"
                   *ngIf="appuntamento.content.tiStato !== 'A' && appuntamento.content.tiStato !== 'C' && appuntamento.content.tiStato !== 'T'&& appuntamento.content.tiStato !== 'M'">
                  <svg class="icon icon-danger p-1 rounded-circle">
                    <use href="./content/svg/sprites.svg#it-delete"></use>
                  </svg>
                </a>
              </td>
              <ng-template #sendApp>
                <td (click)="sendAppointment(appuntamento)"></td>
              </ng-template>
            </tr>
            </tbody>
          </table>
        </div>
        <form class="position-absolute end-0 mx-4 my-2 no-border" [formGroup]="pageForm">
          <div class="bootstrap-select">
            <label class="text-black text-small fw-bold" jhiTranslate="paginazione.elePerPagina">Elementi per
              pagina:</label>
            <select id="defaultSelect" formControlName="numEle" class="text-color text-center fw-bold"
                    style="border: none">
              <option value="10" class="fw-bold">10</option>
              <option value="25" class="fw-bold">25</option>
              <option value="50" class="fw-bold">50</option>
              <option value="100" class="fw-bold">100</option>
            </select>
          </div>
        </form>
        <nav class="pagination-wrapper justify-content-center pagination-total"
             aria-label="Esempio di navigazione responsive della pagina" *ngIf="this.appuntamenti.length > 0">
          <ul class="pagination justify-content-center">
            <li class="page-item" [ngClass]="{'disabled c-normal': this.Isfirst === 'true' || Totalpages === 1}">
              <a class="page-link" (click)="paginaPrecedente()">
                <svg class="icon icon-primary icon-color">
                  <use href="./content/svg/sprites.svg#it-chevron-left"></use>
                </svg>
                <span class="visually-hidden">Pagina precedente</span>
              </a>
            </li>
            <li class="page-item d-none d-sm-flex" *ngFor="let p of [].constructor(Totalpages); index as i"
                (click)="paginaCorrente != i ? vaiAPagina(i) : ''">
              <a class="page-link item-hover"
                 [ngClass]="{'border primary-border text-color': paginaCorrente == i}">{{i + 1 }}</a>
            </li>
            <li class="page-item" [ngClass]="{'disabled c-normal': Islast === 'true' || Totalpages === 1}">
              <a class="page-link" (click)="paginaSuccessiva()">
                <span class="visually-hidden">Pagina successiva</span>
                <svg class="icon icon-primary icon-color">
                  <use href="./content/svg/sprites.svg#it-chevron-right"></use>
                </svg>
              </a>
            </li>
          </ul>
          <p>{{Totalelement}}<span jhiTranslate="paginazione.totale">totale</span><span
            jhiTranslate="paginazione.elementi">elementi</span></p>
        </nav>
      </div>
    </div>
    <div class="card card-bg border-bottom-card p-2 background-primary-before w-75"
         *ngIf="this.appuntamenti == null && !loading || this.appuntamenti.length === 0 && !loading">
      <div style="margin-top: 4rem">
        <h3 class="fw-bold" style="margin-bottom: 3rem">Non ci sono appuntamenti.</h3>
        <h4>Non sono stati rilevati appuntamenti registrati a tuo nome.</h4>
      </div>
    </div>
  </div>
  <div class="container" style="align-content: space-around; display: contents;">
    <button (click)="goToNuovoAppuntamento()" class="btn btn-icon btn-primary primary-button" style="margin-top: 2rem">
      <svg class="icon icon-white">
        <use href="./content/svg/sprites.svg#it-plus"></use>
      </svg>
      <span jhiTranslate="riepilogoAppuntamento.NuovoAppuntamento">Nuovo Appuntamento</span>
    </button>
  </div>

  <div class="modal fade" tabindex="-1" role="dialog" id="modal1" aria-labelledby="modalCenterTitle">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="modal-title h5 no_toc" id="modalCenterTitle">Cancellare l'appuntamento?</h2>
          <button class="btn-close" type="button" data-bs-dismiss="modal"
                  aria-label="Chiudi finestra modale">
            <svg class="icon">
              <use href="./content/svg/sprites.svg#it-close"></use>
            </svg>
          </button>
        </div>
        <div class="modal-body " style="text-align: left">
          <p>Premere il pulsante conferma per cancellare l'appuntamento.</p>
        </div>
        <div class="modal-footer">
          <button class="btn btn-outline-primary btn-sm primary-outline-button" type="button" data-bs-dismiss="modal">
            <span jhiTranslate="modale.annulla">Annulla</span>
          </button>
          <button class="btn btn-primary btn-sm primary-button" type="button" data-bs-dismiss="modal"
                  (click)="annullaAppuntamento()">
            <span jhiTranslate="modale.conferma">Conferma</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
